import axios from "axios";
import { BRANCH_FORBIDDEN_CODE, CSRF_STORAGE_KEY, LOCAL_CSRF_TOKEN, LOCAL_STORAGE_AUTH_CHECK_KEY } from "~/shared/constants/auth";
import { getCookieValue } from "~/shared/lib/auth";

// kenny: path 형식은 이미 정해져 있어서 변경할 수 없음
const baseUrl = import.meta.env.VITE_BASE_API_URL;

function getCSRFToken(): string {
  const fromCookie = getCookieValue("csrftoken");
  if (fromCookie) return fromCookie;
  const fromStorage = localStorage.getItem(CSRF_STORAGE_KEY);
  if (fromStorage) return fromStorage;
  return LOCAL_CSRF_TOKEN;
}

const axiosMultipartInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
});

axiosMultipartInstance.interceptors.request.use((config) => {
  config.headers["X-CSRFToken"] = getCSRFToken();
  return config;
});

axiosMultipartInstance.interceptors.response.use(
  (response) => {
    const csrftoken = getCookieValue("csrftoken");
    if (csrftoken) {
      localStorage.setItem(CSRF_STORAGE_KEY, csrftoken);
    }
    return response;
  },
  (error) => {
    // kenny: 레거시 백엔드에서 401대신 403을 unauthorized로 처리하고 있음
    // CSRF 토큰 오류는 로그아웃 처리하지 않음
    const isCsrfError =
      error.response?.status === 403 &&
      typeof error.response?.data?.detail === "string" &&
      error.response.data.detail.includes("CSRF");
    // 권한 없는 매장 403 은 로그인이 멀쩡하므로 로그아웃시키지 않는다 (FR-AUTH-011)
    // FALLBACK: permission 조합 시 code 가 누락될 수 있으므로 URL 패턴도 함께 확인
    const isBranchForbidden =
      error.response?.status === 403 &&
      (error.response?.data?.code === BRANCH_FORBIDDEN_CODE ||
        error.config?.url?.includes("branches/"));

    if (error.response?.status === 403 && !isCsrfError && !isBranchForbidden) {
      window.localStorage.removeItem(LOCAL_STORAGE_AUTH_CHECK_KEY);
      if (!window.localStorage.getItem("redirectAfterLogin") && !window.location.pathname.startsWith("/login")) {
        const currentPath = window.location.pathname + window.location.search;
        window.localStorage.setItem("redirectAfterLogin", currentPath);
      }
      const currentLanguage = window.location.search.split("language=")[1]?.split("&")[0] ?? "ko";
      window.location.href = `/login?language=${currentLanguage}`;
    }
    return Promise.reject(error);
  }
);

export default axiosMultipartInstance;
